import type { DocumentData, DocumentSnapshot, QueryDocumentSnapshot } from 'firebase/firestore';

import { FirestoreListSyncUtil } from '@src/util/firestoreListSync';

const firestoreListSyncUtil = new FirestoreListSyncUtil();

/**
 * Turns a Firestore snapshot into a list row.
 *
 * Timestamps are serialized to the `{ _seconds, _nanoseconds }` shape Elastic `_source`
 * already uses, so a Firestore-materialized row is drop-in compatible with columns and
 * mappers written for Elastic-fed lists.
 */
export const toListRow = <T>(snapshot: QueryDocumentSnapshot | DocumentSnapshot): T =>
  ({
    ...firestoreListSyncUtil.serializeTimestamps(snapshot.data() as DocumentData),
    id: snapshot.id,
  }) as T;

export default toListRow;
